import type { auth as en } from "../en/auth";
import type { Messages } from "../types";

export const auth: Messages<typeof en> = {
  welcomeBack: "أهلاً بعودتك",
  signInHint: "سجّل الدخول إلى مؤسستك في منصة ملفك.",
  createAccount: "أنشئ مؤسستك",
  signupHint: "البداية مجانية. اربط إنستغرام في أقل من دقيقة.",
  email: "البريد الإلكتروني",
  password: "كلمة المرور",
  name: "اسمك",
  orgName: "اسم النشاط أو العلامة التجارية",
  orgNameHint: "يمكنك دعوة فريقك لاحقاً.",
  showPassword: "إظهار كلمة المرور",
  hidePassword: "إخفاء كلمة المرور",
  signIn: "تسجيل الدخول",
  signingIn: "جارٍ الدخول…",
  signUp: "إنشاء المؤسسة",
  signingUp: "جارٍ الإنشاء…",
  noAccount: "جديد على ملفك؟",
  haveAccount: "لديك مؤسسة؟",
  goSignup: "أنشئ واحدة",
  goLogin: "سجّل الدخول",
  badCredentials: "البريد الإلكتروني أو كلمة المرور غير صحيحة.",
  emailTaken: "يوجد حساب بهذا البريد الإلكتروني.",
  sessionExpired: "انتهت جلستك. سجّل الدخول من جديد.",
  signedOut: "تم تسجيل خروجك.",
  demoHint: "تجريبي: {{email}} · {{password}}",
  useDemo: "استخدم الحساب التجريبي",
  passwordRule: "8 أحرف على الأقل",
  invalidEmail: "أدخل بريداً إلكترونياً صحيحاً",
  required: "مطلوب",
  terms: "بالمتابعة فإنك توافق على الشروط وسياسة الخصوصية.",
  heroTitle: "كل تعليق ورسالة، يُرَدّ عليها بصوت علامتك التجارية",
  heroText: "ملفك يجمع تعليقات ورسائل إنستغرام في صندوق واحد، ويصوغ الردود بالذكاء الاصطناعي، ويخفي الرسائل المزعجة تلقائياً، ويخبرك بأفضل وقت للنشر.",
  heroBullets: {
    inbox: "صندوق واحد للتعليقات والرسائل",
    automation: "أتمتة تثق بها: تلقائي، أو بعد الموافقة، أو اقتراح فقط",
    insights: "تحليلات وأفضل أوقات النشر من جمهورك أنت",
    arabic: "عربي أولاً، ويتقن الإنجليزية",
  },
  heroQuote: "صرنا نرد على كل سؤال عن السعر خلال ثوانٍ، حتى الساعة 2 فجراً.",
  heroQuoteBy: "أحد عملاء ملفك، عمّان",
  stats: {
    replies: "رد تلقائي هذا الأسبوع",
    saved: "ساعة تم توفيرها",
    response: "متوسط سرعة الرد",
  },
  createOrg: {
    title: "أنشئ مؤسستك",
    hint: "حسابك غير مرتبط بأي مؤسسة بعد. اكتب اسم نشاطك أو علامتك التجارية للبدء.",
    signedInAs: "مسجّل الدخول باسم",
    nameHint: "ستكون المالك، ويمكنك دعوة فريقك لاحقاً.",
    submit: "إنشاء المؤسسة",
    creating: "جارٍ الإنشاء…",
    trialNote: "تبدأ المؤسسات الجديدة بفترة تجريبية مجانية.",
    signOut: "تسجيل الخروج",
  },
};
